import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
// import { FormControl} from '@angular/forms';
import { LoadJsService } from '../../load-js/load-js.service';
import {URLSearchParams} from '@angular/http';


@Component({
  selector: 'app-releasestb-view',
  templateUrl: './releasestb-view.component.html',
  styleUrls: ['./releasestb.component.css']
})
export class ReleasestbViewComponent implements OnInit {
 
  textSearch = new FormControl('');
  workorderList : any = {};
  STBList: any = [];
  Viewrelease: any = {};
  listdraft: any = [];
  listsubmit: any = {};
  ViewSTB: any = {};
  paging : any = {};
  Billingtype : any = [];
  Servicetype : any = [];
  partnername : any = [];
  
  pushProses = false;

  msearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  alert_act='';
  alert_actmsg='';

  table_load = false

  isOne= false
  alert_failed = false
  alert_success = false
  alert_redirect = false

  data_table : any = []

  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJS: LoadJsService,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadStart();
  }

  redirectList(params: any) {
    this.router.navigate([params]);
  }

  loadStart() {
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != '' && params.search != undefined ){
          console.log('search');
          console.log(params.search);
         this.msearch = params.search; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         //this.loadSTB(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          console.log(this.queryParams);
          console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          //this.loadSTB(this.queryParams);
        }
      });

    let id = this.route.snapshot.paramMap.get('id');
    this.loadDraft(id)
    this.loadSubmit(id)
    this.loadDetail(id)
    this.LoadJS.loadScriptOrderService()
  }

  refreshPageOld() {
    this.ngOnInit()
    this.msearch = ''
  }

  refreshPage() {
    
    this.msearch = '';
    this.searchQueryParams = '?partnerid='+this.Viewrelease.partnerid;
    //this.loadSTB(this.searchQueryParams);
    let qpost = {'partnerid':this.Viewrelease.partnerid};
    this.loadSTBPOST(qpost);
  }

  queryStr(options: any){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  onActionClick(act:any, item: any) {
    this.alert_act = act
    // console.log(id, act)
  }

  loadDetail(id:any){
    return this.partnerService.GetReleasestbdetail(id).subscribe((output: any) => {
      console.log(output);
         this.Viewrelease = output
    })
  }

  loadDraft(id:any){
    return this.partnerService.GetListreleasedraft(id).subscribe((output: any) => {
      console.log(output);
         this.listdraft = output.data
    })
  }
  loadSubmit(id:any){
    return this.partnerService.GetListreleasesubmit(id).subscribe((output: any) => {
      console.log(output);
         this.listsubmit = output.data
    })
  }

  loadSTB(params: any) {
    this.table_load = true
    return this.partnerService.GetListstbavail(params).subscribe((output: any) => {
    //return this.partnerService.PostListstbavail(params).subscribe((output: any) => {
    console.log(output);
      this.table_load = false

      this.STBList = output.data
      this.partnername = output.partnername
      

      this.STBList.forEach(row => {
        this.data_table.forEach(dt => {
          if( dt.sn == row.sn ){
            row.pushStb = true
          }
        })
      });

    })
  }

  loadSTBPOST(params: any) {
    this.table_load = true
    //return this.partnerService.GetListstbavail(params).subscribe((output: any) => {
    return this.partnerService.PostListstbavail(params).subscribe((output: any) => {
    console.log(output);
      this.table_load = false

      this.STBList = output.data
      this.partnername = output.partnername
      

      this.STBList.forEach(row => {
        this.data_table.forEach(dt => {
          if( dt.sn == row.sn ){
            row.pushStb = true
          }
        })
      });

    })
  }

  pushAllStb()
  {
    for (let item of this.STBList) {
      
      if (( this.listdraft.findIndex(obj => obj.sn == item.sn) == -1 )) {
        this.pushStb(item.sn); 
      }
    }

  }

  search()
  {
    let qpost = {};
    this.querySearch = true;
    if ( this.msearch != undefined ){
      this.searchQueryParams = this.queryParams+'partnerid='+this.Viewrelease.partnerid+'&search='+this.msearch;
      qpost = {'partnerid':this.Viewrelease.partnerid,'search':this.msearch};
      //alert('undefined');
    }else{
      this.searchQueryParams = this.queryParams+'partnerid='+this.Viewrelease.partnerid;
      qpost = {'partnerid':this.Viewrelease.partnerid};
     // alert('empty');
    }
    console.log(this.msearch, qpost);
    //this.loadSTB(this.searchQueryParams);
    this.loadSTBPOST(qpost);
  }

  redirectSetlayanan(params: any) {
    this.router.navigate([params]);
  }

  queryStrSearch()
  {
    if ( this.msearch ){
      return '&search='+this.msearch;
    }else{
      return '';
    }
  }

  check(item:any) {
    // return (item.sn == this.data_table);
  }

  checksn(item) {
    if ( this.listdraft.findIndex(obj => obj.sn == item) == -1 ) {
        return false;
      }else{
        return true;
      }

    // return (item.sn == this.data_table);
  }

  remove(item:any) {
    // this.data_table.splice(item, 1);
    // item.pushStb = false

    let id = this.route.snapshot.paramMap.get('id');
    this.partnerService.PostRemovereleasestbdraft(item.id).subscribe((output: any) => {
      if(output.status){
        console.log('removed')
        // this.loadDraft(id)
        this.ngOnInit()
          
      } else {
        console.log('gagal remove')
      }
    })
  }

  pushStb(item:any) {
    // this.data_table.push(item)
    // item.pushStb = true

    let id = this.route.snapshot.paramMap.get('id');
    return this.partnerService.PostUploadrelease1(id, item).subscribe((output: any) => {
      console.log(output);
      if(output.status){

         this.loadDraft(id);

        //this.ngOnInit()
        
        
      }else{
        console.log('gagal')
      }

      // console.log(this.data_table)
    });
  }

  submitall(item:any){

    let id = this.route.snapshot.paramMap.get('id');
    return this.partnerService.PostSubmitreleasestb(id, item).subscribe((output: any) => {
      console.log(output);
      if(output.status){

        console.log('yes')
        // this.loadDraft(id)
        this.ngOnInit()
        
      }else{
        console.log('gagal')
      }

      // console.log(this.data_table)
    });
  }

  
}
